import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { FC } from 'react'
import Tube from '../../../../types/api/tube'
import { useUpdateTubeMutation } from '../../../../store/api/tubes-api'
import useErrorModal from '../../../../hooks/api/use-error-modal'

const { confirm } = Modal

interface DeleteProps {
    tube: Tube
}

const Delete: FC<DeleteProps> = ({ tube }) => {
    const stamp = tube.stamps ? tube.stamps[0] : undefined

    const [updateTube, updateTubeState] = useUpdateTubeMutation()

    useErrorModal(updateTubeState, 'Не удалось удалить штамп из тубы')

    const onClick = () => {
        confirm({
            title: `Удалить штамп?`,
            icon: <ExclamationCircleFilled />,
            content: `Вы действительно хотите удалить текущий штамп из Тубуса №${tube.number}`,
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk,
        })
    }

    const onOk = async () => {
        if (stamp) {
            await updateTube({
                docId: tube.documentId,
                body: {
                    data: {
                        stamps: {
                            disconnect: [stamp.documentId],
                        },
                    },
                },
            }).unwrap()
        }
    }

    return (
        <>
            {!!stamp && (
                <Button
                    size={'small'}
                    icon={<DeleteOutlined />}
                    title={'Удалить штамп'}
                    color='danger'
                    variant='outlined'
                    onClick={onClick}
                />
            )}
        </>
    )
}

export default Delete
